import type { CSSProperties } from 'react'
import svgPathsFa from '@/lib/svg-hamishon-fa'
import svgPathsEn from '@/lib/svg-hamishon-en'

/** Shared official artwork: also renders before client providers are ready. */
export function HamishonLogoArtwork({ className, style, lang, label = 'همیشان' }: {
  className?: string
  style?: CSSProperties
  lang: 'fa' | 'en'
  label?: string
}) {
  if (lang === 'en') {
    return (
      <svg
        className={className}
        style={style}
        viewBox="0 0 700 135"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Hamishon"
      >
        <g transform="translate(9.97,116.70) scale(1,-1)">
          <path d={svgPathsEn.p3f978a00} fill="currentColor" />
        </g>
        <g transform="translate(33.20,58.70) scale(1,-1)">
          <path d={svgPathsEn.p3d351180} fill="#F1D480" />
        </g>
        <g transform="translate(33.20,93.25) scale(1,-1)">
          <path d={svgPathsEn.pffaf300} fill="#F1D480" />
        </g>

        <g transform="translate(99.26,99.27) scale(1,-1)">
          <path d={svgPathsEn.p33578e00} fill="currentColor" />
        </g>
        <g transform="translate(179.99,99.28) scale(1,-1)">
          <path d={svgPathsEn.p10dd5cc0} fill="currentColor" />
        </g>
        <g transform="translate(263.53,99.28) scale(1,-1)">
          <path d={svgPathsEn.p2c5221f0} fill="currentColor" />
        </g>
        <g transform="translate(359.99,99.28) scale(1,-1)">
          <path d={svgPathsEn.p3c1be100} fill="currentColor" />
        </g>
        <g transform="translate(393.82,99.27) scale(1,-1)">
          <path d={svgPathsEn.p12369f00} fill="currentColor" />
        </g>
        <g transform="translate(463.60,99.27) scale(1,-1)">
          <path d={svgPathsEn.p33578e00} fill="currentColor" />
        </g>
        <g transform="translate(543.21,99.29) scale(1,-1)">
          <path d={svgPathsEn.p3ae8c00} fill="currentColor" />
        </g>
        <g transform="translate(624.85,99.28) scale(1,-1)">
          <path d={svgPathsEn.p29786c0} fill="currentColor" />
        </g>

        <g transform="translate(680.10,128.62) scale(1,-1)">
          <path d={svgPathsEn.p37e3ac00} fill="currentColor" />
        </g>
        <g transform="translate(683.26,125.86) scale(1,-1)">
          <path d={svgPathsEn.p11dc57c0} fill="currentColor" />
        </g>
      </svg>
    )
  }

  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 538 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <g transform="translate(462.4,116.14) scale(1,-1)">
        <path d={svgPathsFa.p2ab3bc00} fill="currentColor" />
      </g>
      <g transform="translate(485.56,58.23) scale(1,-1)">
        <path d={svgPathsFa.p190fb800} fill="#F1D480" />
      </g>
      <g transform="translate(485.56,92.71) scale(1,-1)">
        <path d={svgPathsFa.p190fb800} fill="#F1D480" />
      </g>
      <g transform="translate(114.37,99.15) scale(1,-1)">
        <path d={svgPathsFa.p2f7bd00} fill="currentColor" />
      </g>
      <g transform="translate(160.76,37.20) scale(1,-1)">
        <path d={svgPathsFa.p139df500} fill="currentColor" />
      </g>
      <g transform="translate(241.81,98.74) scale(1,-1)">
        <path d={svgPathsFa.p38e79c40} fill="currentColor" />
      </g>
      <g transform="translate(21.58,99.14) scale(1,-1)">
        <path d={svgPathsFa.p1f222100} fill="currentColor" />
      </g>
      <g transform="translate(53.23,58.50) scale(1,-1)">
        <path d={svgPathsFa.p39173500} fill="currentColor" />
      </g>
      <g transform="translate(10.01,128.02) scale(1,-1)">
        <path d={svgPathsFa.p11dcb500} fill="currentColor" />
      </g>
      <g transform="translate(13.13,125.26) scale(1,-1)">
        <path d={svgPathsFa.p2b914900} fill="currentColor" />
      </g>
    </svg>
  )
}
